import { render, staticRenderFns } from "./WootButtonV2.vue?vue&type=template&id=5ffcecde&"
import script from "./WootButtonV2.vue?vue&type=script&lang=js&"
export * from "./WootButtonV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports